import styled from 'styled-components'

export const NavigationSliderWrapper = styled.div`
  & input {
    color: #000 !important;
  }
`
